"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getMetricsPublisherChainAsync = exports.getMetricsPublisherAsync = exports.PublisherChain = exports.publishTimer = exports.publishCounter = exports.publishString = void 0;
const katal_metrics_instance_1 = require("./katal_metrics_instance");
exports.publishString = (key, value) => (publisher) => {
    publisher.publishString(key, value);
    return publisher;
};
exports.publishCounter = (key, value) => (publisher) => {
    publisher.publishCounterMonitor(key, value);
    return publisher;
};
exports.publishTimer = (key, value) => (publisher) => {
    publisher.publishTimerMonitor(key, value);
    return publisher;
};
class PublisherChain {
    constructor(publisher) {
        this.publisher = publisher;
    }
    publishString(key, value) {
        exports.publishString(key, value)(this.publisher);
        return this;
    }
    publishCounter(key, value) {
        exports.publishCounter(key, value)(this.publisher);
        return this;
    }
    publishTimer(key, value) {
        exports.publishTimer(key, value)(this.publisher);
        return this;
    }
}
exports.PublisherChain = PublisherChain;
exports.getMetricsPublisherAsync = katal_metrics_instance_1.getMetricsActionPublisherAsync;
exports.getMetricsPublisherChainAsync = (method) => exports.getMetricsPublisherAsync(method).then((publisher) => new PublisherChain(publisher));
